(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("leaflet-moving-rotated-marker"), require("vue2-leaflet"));
	else if(typeof define === 'function' && define.amd)
		define(["leaflet", "leaflet-moving-rotated-marker", "vue2-leaflet"], factory);
	else if(typeof exports === 'object')
		exports["Vue2LeafletMovingRotatedMarker"] = factory(require("leaflet"), require("leaflet-moving-rotated-marker"), require("vue2-leaflet"));
	else
		root["Vue2LeafletMovingRotatedMarker"] = factory(root["leaflet"], root["leaflet-moving-rotated-marker"], root["vue2-leaflet"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(3),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _leaflet = __webpack_require__(4);

var L = _interopRequireWildcard(_leaflet);

__webpack_require__(5);

var _vue2Leaflet = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var props = {
    draggable: {
        type: Boolean,
        custom: true,
        default: false
    },
    visible: {
        type: Boolean,
        custom: true,
        default: true
    },
    latLng: {
        type: [Object, Array],
        custom: true
    },
    icon: {
        custom: false,
        default: function _default() {
            return new L.Icon.Default();
        }
    },
    zIndexOffset: {
        type: Number,
        custom: false
    },
    options: {
        type: Object,
        default: function _default() {
            return {};
        }
    },
    duration: {
        type: Number,
        required: true
    },
    rotationAngle: {
        type: Number,
        default: 0
    },
    rotationOrigin: {
        type: String,
        default: 'center center'
    }
};

exports.default = {
    name: 'l-moving-rotated-marker',
    props: props,
    data: function data() {
        return {
            ready: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        var options = this.options;
        if (this.icon) {
            options.icon = this.icon;
        }
        options.draggable = this.draggable;
        this.mapObject = L.marker(this.latLng, options);
        this.mapObject.on('move', function (ev) {
            if (Array.isArray(_this.latLng)) {
                _this.latLng[0] = ev.latlng.lat;
                _this.latLng[1] = ev.latlng.lng;
            } else {
                _this.latLng.lat = ev.latlng.lat;
                _this.latLng.lng = ev.latlng.lng;
            }
        });
        L.DomEvent.on(this.mapObject, this.$listeners);
        (0, _vue2Leaflet.propsBinder)(this, this.mapObject, props);
        this.ready = true;
        this.parentContainer = (0, _vue2Leaflet.findRealParent)(this.$parent);
        this.parentContainer.addLayer(this, !this.visible);
    },
    beforeDestroy: function beforeDestroy() {
        this.parentContainer.removeLayer(this);
    },

    methods: {
        setDraggable: function setDraggable(newVal, oldVal) {
            if (this.mapObject.dragging) {
                newVal ? this.mapObject.dragging.enable() : this.mapObject.dragging.disable();
            }
        },
        setVisible: function setVisible(newVal, oldVal) {
            if (newVal === oldVal) return;
            if (this.mapObject) {
                if (newVal) {
                    this.parentContainer.addLayer(this);
                } else {
                    this.parentContainer.removeLayer(this);
                }
            }
        },
        setLatLng: function setLatLng(newVal) {
            if (newVal == null) {
                return;
            }

            if (this.mapObject) {
                var oldLatLng = this.mapObject.getLatLng();
                var newLatLng = {
                    lat: newVal[0] || newVal.lat,
                    lng: newVal[1] || newVal.lng
                };
                if (newLatLng.lat !== oldLatLng.lat || newLatLng.lng !== oldLatLng.lng) {
                    this.mapObject.slideTo(newLatLng, {
                        duration: this.duration
                    });
                }
            }
        }
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.ready) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("leaflet");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("leaflet-moving-rotated-marker");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("vue2-leaflet");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// Vue2LeafletMovingRotatedMarker.js